// In-house referral attribution — no third-party trackers.
//
// captureReferral() runs once at app boot (App.js) and on /r/:code. If the
// URL carries ?ref=<code> (or utm_* params), the capture context is stored in
// localStorage with a 30-day attribution window, FIRST touch wins — a later
// visit with a different code does not steal credit. localStorage survives
// the multi-step signup wizard and the Stripe checkout round-trip, which is
// what makes attribution reliable end-to-end.
//
// The stored context is read at the three persistence points:
//  - /api/auth/signup            -> users.referral_source
//  - /api/signup/checkout        -> Stripe metadata -> organizations (medical)
//  - /api/signup/create-law-firm -> organizations (law firm)

const KEY = 'ml-ref';
const WINDOW_DAYS = 30;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

// Normalize a raw code to the canonical slug shape (mirrors the server's
// validation and the DB CHECK constraint).
export function cleanRefCode(raw) {
  return String(raw || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 40);
}

export function captureReferral(explicitCode) {
  try {
    const q = new URLSearchParams(window.location.search);
    const code = cleanRefCode(explicitCode || q.get('ref'));
    const utms = {};
    UTM_KEYS.forEach((k) => { const v = q.get(k); if (v) utms[k] = v.slice(0, 120); });
    if (!code && !Object.keys(utms).length) return;

    // First touch wins: keep an existing capture unless it has no code and
    // this visit brings one.
    const existing = getReferral();
    if (existing?.code && existing.code !== '') return;
    if (existing && !code) return;

    localStorage.setItem(KEY, JSON.stringify({
      code: code || null,
      utms,
      landing: window.location.pathname,
      captured_at: new Date().toISOString(),
    }));
  } catch { /* storage unavailable — attribution is best-effort */ }
}

export function getReferral() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (Date.now() - new Date(d.captured_at).getTime() > WINDOW_DAYS * 864e5) {
      localStorage.removeItem(KEY);
      return null;
    }
    return d;
  } catch { return null; }
}
